import React, { useState } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select"; // Import react-select
import {
  AddClientSchema,
  EditClientSchema,
  clientValidationSchema,
} from "../../../../components/Helpers";
import ModalComponent from "../../../../components/Modal";
import { requestClientAction } from "../../../../Redux/ClientState/ClientActionCreator";
import CustomDropdown from "../../../../components/CustomDropdown";
import Loader from "../../../../components/Loader";
import TextInput from "../../../../components/TextInput";
import { toast } from "react-toastify";
import zipcodes from 'zipcodes';

const AddClientModal = ({
  onClose,
  show, 
  onAddClient,
  title,
  initialValues,
}) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAddressAutoFilled, setIsAddressAutoFilled] = useState(false);
  const dispatch = useDispatch();
  // const editClientReducer = useSelector((state) => state.EditClientReducer);
  const clientByIdReducer = useSelector((state) => state.ClientByIdReducer);

  const countryOptions = [
    { value: "USA", label: "USA" }
  ];

  const handleSubmit = (values) => { 
    onAddClient(values);
  };

  const handleCloseModals = () => {
    setIsAddModalOpen(false);
    onClose();
  };

  const handleZipCodeChange = (e, setFieldValue, values) => {
    const zipCode = e.target.value;
    
    // Check if country is USA
    if (values.country === 'USA') {
      // Check if zipcode is 5 digits long (standard US format)
      if (zipCode.length === 5) {
        const location = zipcodes.lookup(zipCode);
        // If valid US zipcode, auto-fill city and state
        if (location) {
          setFieldValue('city', location.city);
          setFieldValue('state', location.state);
          setFieldValue('country', 'USA');
          setIsAddressAutoFilled(true);
          setFieldValue('zip', zipCode);
        } else {
          // Show error if zipcode lookup fails
          toast.error('Invalid ZIP code');
          setIsAddressAutoFilled(false);
        }
      } else {
        // Reset auto-fill if zipcode length is not 5
        setIsAddressAutoFilled(false);
      }
    }
  };

  return (
    <ModalComponent show={show} onClose={onClose} title={title}>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={clientValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, handleChange, setFieldValue, values }) => (
        <Form className="h-max-[85vh] overflow-y-scroll no-scrollbar">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="pt-2">
            <TextInput
              value={values?.name}
              name="name"
              placeholder="Client Name"
              handleChange={handleChange}
              type="text"
              classes="w-full"
              legend
            />
            {errors.name && touched.name && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.name}</div>
            )}
          </div>
          <div className="pt-2">
            <TextInput
              value={values?.email}
              name="email"
              placeholder="Client Email"
              handleChange={handleChange}
              type="email"
              classes="w-full"
              legend
            />
            {errors.email && touched.email && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.email}</div>
            )}
          </div>
          <div className="pt-2">
              <TextInput  
              value={values?.addressLine1}
              name="addressLine1"
              placeholder="Address Line 1"
              handleChange={handleChange}
              type="text"
              classes="w-full"
              legend
            />
            {errors.addressLine1 && touched.addressLine1 && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.addressLine1}</div>
            )}
          </div>
      
          <div className="pt-2">
            <TextInput
              value={values?.addressLine2}
              name="addressLine2"
              placeholder="Address Line 2"
              handleChange={handleChange}
              type="text"
              classes="w-full"
              legend
            />
            {errors.addressLine2 && touched.addressLine2 && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.addressLine2}</div>
            )}
            </div>
      
          <div className="pt-2">
            <TextInput
              value={values?.city}
              name="city"
              placeholder="City"
              handleChange={handleChange}
              type="text"
              classes="w-full"
              legend
              isDisabled={isAddressAutoFilled}
            />
            {errors.city && touched.city && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.city}</div>
            )}
          </div>
      
          <div className="pt-1">
            <TextInput
              value={values?.state}
              name="state"
              placeholder="State"
              handleChange={handleChange}
              type="text"
              classes="w-full"
              legend
              isDisabled={isAddressAutoFilled}
            />
            {errors.state && touched.state && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.state}</div>
            )}
          </div>


          <div className="pt-2">
            <TextInput
              value={values?.zip}
              name="zip"
              placeholder="Zip"
              handleChange={(e) => {
                // Restrict input to numbers only and max 5 digits
                const value = e.target.value.replace(/\D/g, '').slice(0, 5);
                e.target.value = value;
                handleChange(e);
                handleZipCodeChange(e, setFieldValue, values);
              }}
              type="text"
              classes="w-full"
              legend
              isDisabled={values?.country !== 'USA'}
            />
            {errors.zip && touched.zip && (
              <div className="text-red-500 text-left text-sm mt-1 ">{errors.zip}</div>
            )}
          </div>
      
          <div className="">
            {/* <label className="text-sm text-gray-500" htmlFor="country">
              Country
            </label> */}
            <CustomDropdown
              value={countryOptions?.find(option => option.value === values?.country) || null}
              customClasses="w-full text-left"
              name="country"
              handleChange={(selectedOption) => {
                setFieldValue("country", selectedOption.value);
              }}
              placeholder="Select Country"
              options={countryOptions}
              handleGetOptionValue={(option) => option.value}
              handleGetOptionName={(option) => option.label}
              isDisabled={true}
            />
            {errors.country && touched.country && (
              <div className="text-red-500 text-left text-sm mt-1">{errors.country}</div>
            )}
          </div>
      
          
      
          <div className="col-span-1 sm:col-span-2 flex flex-col sm:flex-row justify-end gap-2 mt-4">
            <button
              type="button"
              className="bg-gray-300 text-black h-10 py-1 px-4 w-full sm:w-40 rounded-lg hover:bg-gray-400"
              onClick={handleCloseModals}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primary text-white h-10 py-1 px-4 w-full sm:w-40 rounded-lg hover:bg-primaryDark"
            >
              Submit
            </button>
          </div>
        </div>
      </Form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default AddClientModal;